import { LocalizedField } from "./_model";
import { Role } from "./user.model";

export interface Survey {
    id: number;
    title: string | LocalizedField<string>;
    frequency: SurveyFrequency;
    description?: string | LocalizedField<string>;
    footer_text?: string | LocalizedField<string>;
    created_at: Date;
    updated_at: Date;
    steps: SurveyStep[];
    key?: string;
    extra?: {
        [key: string | 'extra' | 'group']: string
    };
    has_override_settings: boolean;
    is_notifiable: boolean;
    priority_enabled?: boolean;
    default_frequency_days?: number;
    default_notification_time?: string;
}

export interface SurveyStep {
    id: number;
    survey_id: number;
    type: SurveyStepType;
    title: string | LocalizedField<string>;
    text: string | LocalizedField<string>;
    body: string | LocalizedField<string>;
    min_value?: number;
    max_value?: number;
    min_label?: string;
    max_label?: string;
    step_increment?: number;
    value_representation_type?: SurveyStepRepresentationType;
    choices: SurveyStepChoice[] | LocalizedField<SurveyStepChoice[]>;
    created_at: Date;
    updated_at: Date;
    display_in_chart: boolean;
    chart_type?: SurveyStepChartType;
    key?: string;
    order: number;
    required: boolean;
    include_na_option: boolean;
    conditions: string;
}
export interface SurveyResponse {
    id: number;
    survey_id: number;
    patient_id: string;
    date: Date;
    created_at: Date;
    updated_at: Date;
    answers: SurveyStepChoiceAnswer[];
    created_by?: string;
    created_by_role?: Role;
}

export interface SurveyStepChoiceAnswer {
    id: number;
    survey_response_id: number;
    step_id: number;
    value_type: SurveyStepType;
    value: string;
    created_at: Date;
    updated_at: Date;
}

export interface SurveyStepChoice {
    text: string;
    value: number
}
export enum SurveyFrequency {
    daily = 'D',
    monthly = 'M',
    yearly = 'Y',
    once = 'O',
}
export enum SurveyStepType {
    radio = 'R',
    multiple = 'M',
    text_info = 'T',
    value = 'V',
    description = 'D',
    finalize = 'F',
    sentiment = 'VSS',
    visual_analogue_scale = 'VAS',
    points_of_interest = 'PDI',
    time_span = 'TS'
}

export type SurveyStepChartType = 'bar' | 'line' | 'pie' | 'scatter' | 'body_map';
export type SurveyStepRepresentationType = 'integer' | 'percentage' | 'other';

export enum SurveyTimeSpan { _, minute, hour, day, week };
export const TIME_SPAN_MULTIPLIER = {
    1: 1,
    2: 60,
    3: 60 * 24,
    4: 60 * 24 * 7
}